module.exports = __webpack_public_path__ + "static/img/todayRefund.606b195c.png";